import { DateSeries, IndexSeries, FixedSeries } from '../DataSeries';
import { DataTypes } from './';


/**
 * Save a raw data series
 * 
 * @param {DateSeries|IndexSeries|FixedSeries} data TimeSeries to save to a JSON format
 */
export function saveData(data) {
  if (data instanceof DateSeries && data.isRemoteSeries) {
    return saveRemoteSeries(data, DataTypes.DATE_REMOTE);
  }
  else if (data instanceof DateSeries) {
    return saveDateSeries(data);
  }
  else if (data instanceof IndexSeries && data.isRemoteSeries) {
    return saveRemoteSeries(data, DataTypes.INDEX_REMOTE);
  }
  else if (data instanceof IndexSeries) {
    return saveIndexSeries(data);
  }
  else if (data instanceof FixedSeries && data.isRemoteSeries) {
    return saveRemoteSeries(data, DataTypes.FIXED_REMOTE);
  }
  else if (data instanceof FixedSeries) {
    return saveFixedSeries(data);
  }
  else {
    throw Error('saveData input data class is not recognized');
  }
}


/**
 * Convert an date series into a serialized format
 * 
 * @param {DateSeries} data Input date series to store
 */
function saveDateSeries(data) {
  return {
    type: DataTypes.DATE,
    raw: JSON.stringify(data.getPairs())
  }
}


/**
 * Convert an index series into a serialized format
 * 
 * @param {IndexSeries} data Input index series to store
 */
function saveIndexSeries(data) {
  return {
    type: DataTypes.INDEX,
    raw: JSON.stringify(data.getValues())
  };
}


/**
 * Convert a fixed series into a serialized format
 * 
 * @param {FixedSeries} data Input fixed series to store
 */
function saveFixedSeries(data) {
  let value = data.length ? data[0].value : null;

  return {
    type: DataTypes.FIXED,
    raw: JSON.stringify(value)
  }
}


/**
 * Convert a remote series into a serialized format
 * 
 * @param {DateSeries|IndexSeries|TimeSeries} data Series with REMOTE mixin applied
 */
function saveRemoteSeries(data, dataType) {
  return {
    type: dataType,
    remoteID: data.remoteID
  }
}